import { render } from "./LatestVersion.vue?vue&type=template&id=42c7f2c6"
import script from "./LatestVersion.vue?vue&type=script&lang=js"
export * from "./LatestVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__